import { BaseDataDTO, DailyPricingCurveDTO, DailyPricingDTO, GenericPeriodDTO, LocationMapDTO, MapLocationDTO, MapPriceDTO, MarketDTO, MaterialDTO, MaturityDTO, PeriodCurvesDTO, PeriodDTO, PriceDTO, SpecificationDTO, SpecificationPriceDTO } from "./DTO"
import { BaseData, DailyPricing, DailyPricingCurve, GenericPeriod, LocationMapViewModel, MapLocation, MapPrice, Market, Material, Maturity, Period, PeriodCurve, Price, Specification, SpecificationPrice } from "../../../@type/physical-markets/Model"

export const mapperBaseDataDTOToModel = (base: BaseDataDTO) : BaseData => ({
    Materials: base.m.map(mapperMaterialDTOToModel),
    Units: base.u.map(u => ({
        key: u.k,
        name: u.n
    })),
    MapLocationSettings: base.s ? {
        DaysToWarningAlert: base.s.w,
        DaysToCriticalAlert:base.s.c
    } : null
});

const mapperMaterialDTOToModel = (m: MaterialDTO) : Material => ({
    MaterialID: m.i,
    Material: m.m,
    Origins: m.o.map(o => ({
        OriginID: o.i,
        Origin: o.o,
        Bound: o.b,
        ShowMap: o.s
    })),
    HasMailReport: m.h,
    ReportAccounts: m.r?.map(r => ({
        Name: r.n
    }))
});

export const mapperMarketsDTOToModel = (markets: MarketDTO[]) => 
    markets.map(mapperMarketDTOToModel);

const mapperMarketDTOToModel = (m: MarketDTO) : Market => ({
    MarketID: m.i,
    Future: m.f,
    Name: `${m.lo}${m.f ? '' : ' (flat)'}${m.g ? (' - ' + m.g) : ''}`,
    Location: m.lo,
    Material: m.m,
    Origin: m.o,
    UM: m.u,
    Currency: m.c,
    Periods: m.ps.map(mapperPeriodDTOToModel),
    Maturities: m.ms.map(mapperMaturityDTOToModel),
    MarketDefaultPrecision: m.x,
    MarketBasisPrecision: m.y
});

export const mapperPeriodDTOToModel = (p : PeriodDTO) : Period => ({
    id: p.i,
    MarketID: p.mi,
    Name: p.n,
    Price: p.p,
    User: p.u,
    StartDate: p.st,
    EndDate: p.ed, 
    LastPriceDate: p.lp,
    Maturity: p.m,
    Generic: p.g,
    Maturities: p.ms.map(mapperMaturityDTOToModel),
    DailyPricings: p.dp.map(mapperDailyPricingDTOToModel),
    FutureValue: p.f
});

export const mapperPeriodCurveDTOToModel = (p: PeriodCurvesDTO) : PeriodCurve => ({
    id: p.i,
    Name: p.n,
    Maturity: p.m,
    Currencies: p.cs,
    Units: p.us,
    DailyPricings:p.dp.map(mapperDailyPricingCurveDTOToModel)
});

const mapperMaturityDTOToModel = (m: MaturityDTO) : Maturity => ({
    Value: m.v,
    Label: m.l,
    LastTradeDate: m.d,
    LastPrice: m.p,
    LastPriceDate: m.r
});

const mapperDailyPricingDTOToModel = (d: DailyPricingDTO) : DailyPricing => ({
    id: d.i,
    Date: d.d,
    Price: d.p,
});

const mapperDailyPricingCurveDTOToModel = (d: DailyPricingCurveDTO) : DailyPricingCurve => ({
    id: d.i,
    Date: d.d,
    Price: d.p,
    Manual: d.m,
    Virtual: d.v,
    Prices: d.s.map(mapPriceCurve)
});

const mapPriceCurve = (p: PriceDTO) : Price => ({
    Currency: p. c,
    UM: p.u,
    Basis: p. b,
    Open: p. o,
    High: p. h,
    Low: p. l,
    Future: p. f,
    Flat: p. t
});

export const mapperLocationMapDTOModel = (l: LocationMapDTO) : LocationMapViewModel => ({
    Locations: l.l.map(mapperMapLocationDTOModel),
    Specifications: l.s.map(mapperSpecificationDTOModel),
    GenericPeriods: l.g.map(mapperGenericPeriodDTOModel),
    Units: l.u,
    NoneSpecificationID: l.n
});

const mapperMapLocationDTOModel = (m: MapLocationDTO) : MapLocation => ({
    id: m.i,
    Lat: m.t,
    Lon: m.l,
    Name: m.n,
    OriginID: m.x,
    Origin: m.o,
    Currency: m.c,
    Specifications: m.s.map(mapperSpecificationDTOModel)
});

const mapperSpecificationDTOModel = (s: SpecificationDTO) : Specification => ({
    id: s.i,
    Name: s.n,
    Prices: s.p?.map(mapperSpecificationPriceDTOModel)
});

const mapperGenericPeriodDTOModel = (g: GenericPeriodDTO) : GenericPeriod => ({
    PeriodID: g.i,
    Name: g.n
});

const mapperSpecificationPriceDTOModel = (s: SpecificationPriceDTO) : SpecificationPrice => ({
    PeriodID: s.p,
    PriceDate: s.d,
    BasisPremium: s.b?.map(mapperMapPriceDTOModel),
    Flat: s.f?.map(mapperMapPriceDTOModel)
});

const mapperMapPriceDTOModel = (mp: MapPriceDTO) : MapPrice => ({
    c: mp.c,
    u: mp.u,
    p: mp.p
});